import React, { useState, useEffect, } from 'react'
import { Table, TableBody, Paper, Dialog } from "@material-ui/core";
import { globalGetService, globalDeleteService, globalExportService } from '../../../utils/globalApiServices';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { DownloadAllApi } from './apiServices';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { FleetAdListing, FleetAdTableHeader, AddEditFleetAD } from '../components';
import { downloadFileType, checkApiStatus, } from '../../../utils';
import { EmptyCollection, PageLoader, DeletePopUp, } from '../../../shared_elements';
import STableLoader from '../../../shared_elements/components/skeleton_loader/STableLoader';
import { adFilterOptions, adSmbcFilterOptions } from './index';
import ShowAttachments from '../../../shared_elements/components/ShowAttachments';
import ImportFormat from '../../../shared_elements/components/ImportFormat';
import DeploymentMessage from '../../../shared_elements/components/DeploymentMessage';
import { permissionCheckFnforCamo } from '../../../utils';
import { trackActivity } from '../../../utils/mixpanel';
import { smbcInstance } from '../../../shared_elements/components';
import Pagination from '../../../shared_elements/components/Pagination';
import FleetCTA from '../../../shared_elements/components/FleetCTA';
import STabsLoader from '../../../shared_elements/components/skeleton_loader/STabsLoader';
function FleetMainAd({ match }) {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [isLoading, setLoading] = useState(false)
	const [skeltonLoader, setSkeltonLoader] = useState(false)
	const [deletelist, setDeleteList] = useState({ modal: false, data: null })
	const [fleetAdListing, setFleetAdListing] = useState({ list: [], pagination: {} })
	const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
	const [importFile, setImportFile] = useState({ modal: false, data: null })
	const [addEditFleetAD, setAddEditFleetAD] = useState({ modal: false, data: null, type: '' })
	const [filter, setFilter] = useState()
	const [applicability, setApplicability] = useState([])
	const [attchementsModal, setAttchementsModal] = useState({ modal: false, data: null, })

	useEffect(() => {
		getFleetAdListing({ per_page: 250, asset_type: 2 }, 'skeltonLoader')
		getApplicability()
		trackActivity('Fleet AD - Airworthiness Management', {
			event_type: 'Page Visited',
			page_title: 'Fleet AD'
		});
	}, [])
	const getFleetAdListing = (query, loaderType) => {
		loaderType === "skeltonLoader" ? setSkeltonLoader(true) : setLoading(true)
		globalGetService(`camo/fleet_ad/`, query)
			.then((response) => {
				loaderType === "skeltonLoader" ? setSkeltonLoader(false) : setLoading(false)
				if (checkApiStatus(response)) {
					setFleetAdListing(response?.data)
					setFilter(query)
				}
			})
	}

	const deleteFleetADList = () => {
		setLoading(true)
		globalDeleteService(`camo/fleet_ad/${deletelist?.data?.id}/`)
			.then((response) => {
				setLoading(false); setDeleteList({ modal: false }); getFleetAdListing({ per_page: 250, asset_type: 2 })
				if (checkApiStatus(response)) {
					trackActivity('Fleet AD  Success - Airworthiness Management', {
						event_type: 'Deleted',
						page_title: 'Fleet AD',
						deleted_id: deletelist?.data?.id,
						success_msg: response?.data?.message
					})
					enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
				} else {
					trackActivity('Fleet AD Deleted Failed - Airworthiness Management', {
						event_type: 'Deleted',
						page_title: 'ConFleet AD',
						deleted_id: deletelist?.data?.id,
						error_msg: response?.data?.message
					})
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
				}

			})
	}
	const exportADListing = (extension) => {
		const date = new Date()
		const todayDate = moment(String(date)).format("DD-MM-YYYY")
		setLoading(true);
		globalExportService(`/camo/fleet_ad/2/export/`, { download: extension })
			.then(response => {
				setLoading(false);
				trackActivity('Fleet AD Export - Airworthiness Management', {
					event_type: 'Export',
					page_title: 'Fleet AD',
				})
				downloadFileType(response.data, `fleet_Ad_${todayDate}`, extension)
				enqueueSnackbar("Download fleet AD List Successfully", { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
			});
	}

	const createSortHandler = (key) => {
		let sortQuery = { sort: key };
		if (sortInfo.sort === key) {
			sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
		} else {
			sortQuery = { ...sortQuery, sort_by: 'asc' }
		}
		setSortInfo(sortQuery)
		getFleetAdListing({ ...sortQuery, per_page: 250, asset_type: 2 }, 'pageLoader');
	}
	const getApplicability = () => {
		globalGetService(`console/engine-types/`)
			.then((response) => {
				if (checkApiStatus(response)) {
					setApplicability(response?.data?.data?.engineTypes)
				}
			})
	}

	const deleteAttachements = (files, items, id) => {
		globalDeleteService(`camo/attachment/${id}/delete/?fleet=ad`)
			.then((response) => {
				if (checkApiStatus(response)) {
					getFleetAdListing({ per_page: 250, asset_type: 2 }, 'pageLoader')
					enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Fleet AD Attachment Deleted Success - Airworthiness Management', {
						event_type: 'Deleted',
						page_title: 'Fleet AD',
					})
				} else {
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
					trackActivity('Fleet AD Attachment Deleted Failed - Airworthiness Management', {
						event_type: 'Deleted',
						page_title: 'Fleet AD',
					})
				}
			})

	}
	const openAttachment = (file) => {
		var decodedURL = decodeURIComponent(file);
		window.open(decodedURL, "_blank");
	};

	const filterObj = Object.assign({}, filter, delete filter?.per_page, delete filter?.page, delete filter?.sort, delete filter?.sort_by, delete filter?.asset_type)
	let filterOptions = Object.assign({}, smbcInstance ? adSmbcFilterOptions : adFilterOptions)
	filterOptions = {
		...filterOptions,
		applicability: {
			...filterOptions.applicability,
			options: applicability
		},
	}
	const tabsLoaderCount = window.innerWidth < 768 ? 3 : window.innerWidth < 1024 ? 5 : 9;
	return (
		<section className='camo-fleet-module'>
			<DeploymentMessage />
			{skeltonLoader ? <STabsLoader count={tabsLoaderCount} /> :
				<FleetCTA
					searchPlaceholder="Search ATA Chapter, AD Reference Number, AD Issuing Authority, AD Description"
					onSearch={(value) => getFleetAdListing({ search: value, asset_type: 2, per_page: 250 })}
					permissionCheck={!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C" })}
					addLabel="ADD AD"
					onAddFn={() => setAddEditFleetAD({ modal: true, data: null, type: 'add' })}
					onImportFn={() => setImportFile({ modal: true, data: null })}
					exportMenu={{
						exportReportFn: (file) => exportADListing(file?.extension),
						files: [{ title: 'PDF', extension: 'pdf' }, { title: 'EXCEL', extension: 'xlsx' }],
						disabled: !fleetAdListing?.list?.length,
					}}
					filterObj={filterObj}
					filterOptions={filterOptions}
					getResponseBack={(applyFilter) => getFleetAdListing({ ...applyFilter, page: 1, per_page: 250, asset_type: 2 }, 'pageLoader')}
				/>}
			{skeltonLoader ? <STableLoader count={tabsLoaderCount} size={11} /> :
				<Paper variant='outlined' square style={{ padding: '5px 10px', marginBottom: "5px" }}>
					<div style={{ height: `${window.innerHeight - 220}px`, overflow: 'auto' }}>
						<Table className='mui-table-format' stickyHeader={true}>
							<FleetAdTableHeader
								createSortHandler={(sort) => createSortHandler(sort)}
								sortInfo={sortInfo}
							/>
							<TableBody className='ad-fleet-listing'>
								{fleetAdListing?.list?.map((item, index) =>
									<FleetAdListing
										item={item}
										key={index}
										toggleModalFn={() => setAddEditFleetAD({ modal: true, data: item, type: 'edit' })}
										toggleDelteModalFn={() => setDeleteList({ modal: true, data: item })}
										fleetData={addEditFleetAD.data}
										handleOpenAttachments={() => setAttchementsModal({ modal: true, data: item })}
									/>
								)}
							</TableBody>
						</Table>
						{!fleetAdListing?.list?.length ? <EmptyCollection title="No Records Founds" /> : null}
					</div>
					<Pagination
						pagination={fleetAdListing?.pagination}
						onChangePage={(event, newPage) => getFleetAdListing({ ...filter, asset_type: 2, page: newPage + 1, per_page: fleetAdListing?.pagination?.per_page || 250 }, 'pageLoader')}
						onChangeRowsPerPage={(event) => getFleetAdListing({ ...filter, page: 1, asset_type: 2, per_page: event.target.value }, 'pageLoader')}
					/>
				</Paper>
			}
			{
				addEditFleetAD.modal ?
					<AddEditFleetAD
						fleetData={addEditFleetAD.data}
						modeType={addEditFleetAD.type}
						toggleModalFn={() => setAddEditFleetAD({ modal: false })}
						getResponseBack={() => getFleetAdListing({ per_page: 250, asset_type: 2 })}
					/> : null
			}
			{
				deletelist.modal ?
					<DeletePopUp
						title='Delete Fleet AD'
						deleteRecordFn={() => deleteFleetADList()}
						modal={() => setDeleteList({ modal: true })}
						content='Do you really want to delete this record?'
						toggleModalFn={() => setDeleteList({ modal: false })}

					/> : null

			}
			{importFile.modal ?
				<ImportFormat
					title="Import Fleet AD"
					moduleType='fleet_ad'
					fleet={true}
					moduleName="SampleFile Fleet Ad"
					getResponseBack={() => getFleetAdListing({ per_page: 250, asset_type: 2 })}
					toggleModalFn={() => setImportFile({ modal: false })}
				/> : null
			}
			{
				attchementsModal.modal ?
					<Dialog
						open={true}
						onClose={() => setAttchementsModal({ modal: false, data: null })}
						id="htDialog"
					>
						<ShowAttachments
							handleClose={() => setAttchementsModal({ modal: false, data: null })}
							handleShowAttachments={fleetAdListing?.list.filter(item => item?.id === attchementsModal?.data?.id).map(item => item?.attachments)[0]}
							openAttachment={openAttachment}
							files={{ title: "AD", extension: "zip", key: "" }}
							downloadAllApi={() => DownloadAllApi(attchementsModal.data, 'AD')}
							item={attchementsModal.data}
							removeAttachment={deleteAttachements}
						/>
					</Dialog>
					:
					null
			}
			{isLoading ? <PageLoader /> : null}
		</section >
	)
}

export default withRouter(FleetMainAd)